<template>
    <div>
        <svg id="motionpath" xmlns="http://www.w3.org/2000/svg" viewBox="136 383.31 1240 4000.69">
            <!-- <path id="mpath" d="M951,651 C501,1221 572.37793,1803.94007 572,1968.5 571.61427,2136.45655 1200.59012,2577.75386 1197.5,2745 1194.37854,2913.94242 542.14337,3347.01005 543.5,3511 544.84642,3673.75475 1210,4256 1210,4256" fill="none" stroke = "#000" stroke-width="5" stroke-dasharray="5" /> -->
            <defs>
                <mask id="theMask">
                    <path id="maskPath" d="M951,651 C501,1221 572.37793,1803.94007 572,1968.5 571.61427,2136.45655 1200.59012,2577.75386 1197.5,2745 1194.37854,2913.94242 542.14337,3347.01005 543.5,3511 544.84642,3673.75475 1210,4256 1210,4256" fill="none" stroke="#fff" stroke-width="3" />
                </mask>
            </defs>
            <g id="maskReveal" mask="url(#theMask)">
                <path id="dashedPath" d="M951,651 C501,1221 572.37793,1803.94007 572,1968.5 571.61427,2136.45655 1200.59012,2577.75386 1197.5,2745 1194.37854,2913.94242 542.14337,3347.01005 543.5,3511 544.84642,3673.75475 1210,4256 1210,4256" fill="none" stroke="#fff" stroke-width="1" stroke-dasharray="6" />
            </g>
        </svg> 
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
#motionpath {
    position: absolute;
    left: 0;
    right: 0;
    top: 0px;
    height: 100%;
    margin: auto;
    @media screen and (max-width:767px){
        display: none;
    }
}

svg#motionpath{
    z-index: 99;
    top: 120px;
    @media screen and (max-width:1600px){
        top: 247px;
        right: -79px;
    }
    @media screen and (max-width:1300px){
        top: 192px;
        right: -145px;
    }
    @media screen and (max-width:1199px){
        top: 196px;
        right: -188px;
    }
    @media screen and (max-width:991px){
        top: 169px;
        right: -202px;
    }
}
</style>